var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d3Model"},[_c('div',{ref:"d3Model",staticClass:"d3",attrs:{"id":"d3Model"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }